'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { BaseAnchor } from '@qogita/ui/v2/base-anchor'
import { usePathname, useSearchParams } from 'next/navigation'
import { ComponentProps, Suspense } from 'react'

/**
 * Link to the login page that will redirect back to the current page after login
 */
export function LoginLink(
  props: Omit<ComponentProps<typeof BaseAnchor>, 'href'>,
) {
  const pathname = usePathname() ?? '/dashboard'
  /** If we're on the homepage, we want to redirect to dashboard when logging in */
  const pathnameToUse = pathname === '/' ? '/dashboard' : pathname
  const originalSearchParams = useSearchParams() ?? new URLSearchParams()
  const redirectTo =
    originalSearchParams.size > 0
      ? `${pathnameToUse}?${originalSearchParams}`
      : pathnameToUse
  const loginSearchParams = new URLSearchParams({ redirectTo })

  return (
    <Suspense fallback={<BaseLoginLink {...props} />}>
      <BaseAnchor href={`/login?${loginSearchParams}`} {...props} />
    </Suspense>
  )
}

/**
 * A link to the login page without redirect parameters
 *
 * Can be used as a suspense fallback since it doesn't read the current pathname or search params
 */
function BaseLoginLink(props: Omit<ComponentProps<typeof BaseAnchor>, 'href'>) {
  return <BaseAnchor href="/login" {...props} />
}
